import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  signInWithEmailAndPassword, createUserWithEmailAndPassword, onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../firebase/firebase-config';
import SEO from '../components/SEO';
import ppLogo from '../assets/images/pp-logo.png';
import '../Styles/Desk.css';

export default function DeskAuth({ mode }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => { if (u) navigate('/desk'); });
    return unsub;
  }, [navigate]);

  const isSignup = mode === 'signup';

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      if (isSignup) {
        if (password.length < 8) throw new Error('Password must be at least 8 characters.');
        await createUserWithEmailAndPassword(auth, email.trim(), password);
      } else {
        await signInWithEmailAndPassword(auth, email.trim(), password);
      }
      navigate('/desk');
    } catch (err) {
      const map = {
        'auth/email-already-in-use': 'An account already exists with that email — try signing in instead.',
        'auth/invalid-credential': 'Incorrect email or password.',
        'auth/weak-password': 'Password must be at least 8 characters.',
        'auth/invalid-email': 'Please enter a valid email address.',
      };
      setError(map[err.code] || err.message || 'Something went wrong — please try again.');
    }
    setBusy(false);
  };

  return (
    <>
      <SEO title={`${isSignup ? 'Sign up' : 'Sign in'} — PP Contract Desk`} description="Sign in to your Contract Desk workspace." noIndex />
      <div className="desk-auth-page">
        <div className="desk-auth-card">
          <Link to="/" className="desk-auth-logo"><img src={ppLogo} alt="The PP Studio" /></Link>
          <h1>{isSignup ? 'Create your Contract Desk' : 'Sign in to Contract Desk'}</h1>
          <p className="desk-auth-sub">
            {isSignup
              ? 'Your contracts, obligations, and payments — tracked in one place, not buried in a folder.'
              : 'Welcome back.'}
          </p>

          <form onSubmit={submit}>
            <label>
              <span>Email</span>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
            </label>
            <label>
              <span>Password</span>
              <input type="password" required value={password} onChange={e => setPassword(e.target.value)} placeholder={isSignup ? 'At least 8 characters' : '••••••••'} />
            </label>
            {error && <p className="desk-error">{error}</p>}
            <button type="submit" disabled={busy}>
              {busy ? 'Please wait…' : isSignup ? 'Create account' : 'Sign in'}
            </button>
          </form>

          <p className="desk-auth-switch">
            {isSignup ? (
              <>Already have a workspace? <Link to="/desk/login">Sign in</Link></>
            ) : (
              <>New here? <Link to="/desk/signup">Create a workspace</Link></>
            )}
          </p>
        </div>
      </div>
    </>
  );
}
